module.exports = __webpack_public_path__ + "img/secondary_2x1_z18.7c9610c3.svg";